import { IconAlertTriangle } from "@tabler/icons-react";
import { Alert, Stack, Text } from "@/components/ui";
import { SolicitarAltaCatalogo } from "@/features/solicitudes-catalogo/components/SolicitarAltaCatalogo";
import type { LineaProrrateo } from "@/features/prorrateo/types";
import { clavesNoCatalogadas } from "@/features/prorrateo/utils/conceptos";

/**
 * D-9 (módulo Solicitudes de catálogo) · claves producto/servicio del CFDI que NO están en el
 * catálogo de claves SAT. Bloquean la confirmación del prorrateo (el backend lo valida igual);
 * por cada una el solicitante puede pedir su alta.
 */
export function ClavesSatNoCatalogadasAlert({
  lineas,
  catalogo,
  solicitudId,
  numeroSolicitud,
}: {
  lineas: LineaProrrateo[];
  catalogo: ReadonlySet<string>;
  solicitudId: string;
  numeroSolicitud: number;
}) {
  const faltantes = clavesNoCatalogadas(lineas, catalogo);
  if (faltantes.length === 0) return null;

  return (
    <Alert variant="error" icon={<IconAlertTriangle size={16} stroke={1.7} />}>
      <Stack gap="sm">
        <Text size="sm">
          {faltantes.length === 1
            ? "Una clave producto/servicio del CFDI no está en el catálogo de claves SAT."
            : `${faltantes.length} claves producto/servicio del CFDI no están en el catálogo de claves SAT.`}{" "}
          No podrás confirmar el prorrateo hasta que se den de alta:
        </Text>
        {faltantes.map((l) => (
          <div key={l.claveSat} className="flex flex-col gap-1">
            <Text size="sm" fw={600} ff="mono">
              {l.claveSat}
              {l.claveSatDescripcion && (
                <Text span c="dimmed" fw={400}>
                  {" "}· {l.claveSatDescripcion}
                </Text>
              )}
            </Text>
            <SolicitarAltaCatalogo
              tipo="ClaveSat"
              clave={l.claveSat}
              descripcion={l.claveSatDescripcion || undefined}
              solicitudPagoId={solicitudId}
              numeroSolicitudPago={numeroSolicitud}
            />
          </div>
        ))}
      </Stack>
    </Alert>
  );
}
